'use strict';

angular.module('dnapp', ['ngResource', 'ngSanitize', 'ngTruncate'])
    .config(['$compileProvider', '$sceProvider', function ($compileProvider, $sceProvider) {
        $compileProvider.debugInfoEnabled(false);
        $sceProvider.enabled(false);
    }]);